import { $win, $body } from '../utils/globals'

$win.on('scroll load', function() {
	const headerHeight = $('header').outerHeight();

    if ($(window).scrollTop() >= headerHeight) {
        $('.header').addClass('is-sticky');
    }

    else {
        $('.header').removeClass('is-sticky');
    }
});
